import { GoogleMap, Marker, Circle } from '@react-google-maps/api';
import { useGoogleMaps } from '../../context/GoogleMapsContext';

const ISTANBUL = { lat: 41.0082, lng: 28.9784 };

const MAP_OPTIONS = {
  disableDefaultUI: true,
  zoomControl: true,
  scrollwheel: false,
  styles: [
    { featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] },
  ],
};

const CIRCLE_OPTIONS = {
  strokeColor: '#2563eb',
  strokeOpacity: 0.8,
  strokeWeight: 2,
  fillColor: '#2563eb',
  fillOpacity: 0.1,
};

/**
 * Salt görüntüleme harita önizlemesi (Google Maps).
 * lat/lng doluysa marker + yarıçap dairesi; boşsa nötr İstanbul merkezi + ipucu.
 * Sprint 2.8.5 T6-B: proje standardı Google Maps'e geçirildi (önce react-leaflet/OSM idi).
 */
export function BranchMapPreview({ latitude, longitude, radius }) {
  const { isLoaded } = useGoogleMaps();

  const hasGeo =
    latitude != null && latitude !== '' &&
    longitude != null && longitude !== '' &&
    Number.isFinite(Number(latitude)) && Number.isFinite(Number(longitude));

  const lat = hasGeo ? Number(latitude) : ISTANBUL.lat;
  const lng = hasGeo ? Number(longitude) : ISTANBUL.lng;
  const zoom = hasGeo ? 14 : 10;
  const radiusM = Number(radius) > 0 ? Number(radius) : 100;

  if (!isLoaded) {
    return (
      <div
        className="rounded-lg overflow-hidden border border-slate-200 bg-slate-100 flex items-center justify-center"
        style={{ height: 260 }}
      >
        <div className="w-6 h-6 border-2 border-blue-400 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="rounded-lg overflow-hidden border border-slate-200">
      <GoogleMap
        mapContainerStyle={{ height: 260, width: '100%' }}
        center={{ lat, lng }}
        zoom={zoom}
        options={MAP_OPTIONS}
      >
        {hasGeo && (
          <>
            <Marker position={{ lat, lng }} />
            <Circle center={{ lat, lng }} radius={radiusM} options={CIRCLE_OPTIONS} />
          </>
        )}
      </GoogleMap>
      {!hasGeo && (
        <p className="text-xs text-slate-400 px-3 py-2 bg-slate-50">
          Konum girilmedi — enlem/boylam ekleyince harita güncellenir.
        </p>
      )}
    </div>
  );
}
